import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, getSize, em, getBreakpointValue } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

function getPositionStyles(props, theme) {
  var padding = getSize({
    size: props.padding,
    sizes: theme.spacing
  });
  var navbarOffset = props.navbarOffsetBreakpoint ? getSize({
    size: props.navbarOffsetBreakpoint,
    sizes: theme.breakpoints
  }) : null;
  var asideOffset = props.asideOffsetBreakpoint ? getSize({
    size: props.asideOffsetBreakpoint,
    sizes: theme.breakpoints
  }) : null;

  if (!props.fixed) {
    return {
      padding
    };
  }

  return {
    minHeight: "100vh",
    paddingTop: "calc(var(--mantine-header-height, 0px) + ".concat(padding, ")"),
    paddingBottom: "calc(var(--mantine-footer-height, 0px) + ".concat(padding, ")"),
    paddingLeft: "calc(var(--mantine-navbar-width, 0px) + ".concat(padding, ")"),
    paddingRight: "calc(var(--mantine-aside-width, 0px) + ".concat(padding, ")"),
    ["@media (max-width: ".concat(em(getBreakpointValue(navbarOffset) - 1), ")")]: {
      paddingLeft: padding
    },
    ["@media (max-width: ".concat(em(getBreakpointValue(asideOffset) - 1), ")")]: {
      paddingRight: padding
    }
  };
}

var useStyles = createStyles(function (theme, props) {
  return {
    root: {
      boxSizing: "border-box"
    },
    body: {
      display: "flex",
      boxSizing: "border-box"
    },
    main: __spreadValues({
      flex: 1,
      width: "100vw",
      boxSizing: "border-box"
    }, getPositionStyles(props, theme))
  };
});
export default useStyles;